var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'wgt-footer-nav': true,
  'padded': _vm.value.padded
},style:({ backgroundColor: _vm.value.backgroundColor })},[_c('div',{staticClass:"wgt-bd"},[_c('el-button',{style:(`backgroundColor: ${_vm.value.background};color:${_vm.value.color};width:${_vm.value.width}px;backgroundImage:url(${_vm.value.imgUrl})`),attrs:{"round":""}},[_vm._v(_vm._s(_vm.value.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }